/**
 * This simple interface is a bit of a hack to get around the fact that Winston currently
 * does not support browsers.
 *
 * It is intended that a Nitro logger from @trp/nitro-core-nodejs/log is passed in when
 * using node.js (though technically anything that matches this interface can be used).
 *
 * In the browser, choose from NoopLogger (the default for fetches) or ConsoleLogger
 * depending on if console logging is desired or not.
 *
 * Note that the winston roadmap (https://github.com/winstonjs/winston/blob/master/CONTRIBUTING.md#version-330),
 * claims that the next version will have browser support, so at that point presumably all of this can
 * go away.
 */
export interface Logger {
  debug: (message: string) => any;
  error: (message: string, err?: Error) => any;
  info: (message: string) => any;
  warn: (message: string) => any;
}

export const ConsoleLogger: Logger = {
  debug: (msg) => console.log(msg),
  error: (msg, err) => console.error(msg, err),
  info: (msg) => console.log(msg),
  warn: (msg) => console.log(msg),
};
